import { render, staticRenderFns } from "./TechnicianBoard.vue?vue&type=template&id=1dc667c1"
import script from "./TechnicianBoard.vue?vue&type=script&lang=js"
export * from "./TechnicianBoard.vue?vue&type=script&lang=js"
import style0 from "./TechnicianBoard.vue?vue&type=style&index=0&id=1dc667c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports